import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-cdw-divider',
  templateUrl: './cdw-divider.component.html',
  styleUrls: ['./cdw-divider.component.scss'],
  standalone: false,
})
export class CdwDividerComponent {
  @Input() color!: string;
  @Input() thickness!: string;
}
